(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moyuu-navigation"]) return;
  try {
    
if (!customElements.get('moyuu-mega-navigation')) {
  customElements.define('moyuu-mega-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const closeMenus = (except = null) => this.querySelectorAll('[data-my-mega][open]').forEach(menu => { if (menu !== except) menu.open = false; });
      this.addEventListener('pointerover', event => {
        if (!window.matchMedia('(min-width: 761px) and (hover: hover)').matches || event.pointerType === 'touch') return;
        const menu = event.target.closest('.my-desktop [data-my-mega]');
        if (menu) { closeMenus(menu); menu.open = true; }
        else if (event.target.closest('.my-desktop > a')) closeMenus();
      }, options);
      this.addEventListener('pointerleave', () => {
        if (window.matchMedia('(min-width: 761px) and (hover: hover)').matches && !this.contains(document.activeElement)) closeMenus();
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('.my-menu-shade')) closeMenus();
        const close = event.target.closest('.my-mega-close');
        if (close) { const menu = close.closest('[data-my-mega]'); menu.open = false; menu.querySelector('summary').focus(); }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const menu = event.target.closest('[data-my-mega][open]') || this.querySelector('[data-my-mega][open]');
        if (menu) { event.preventDefault(); closeMenus(); menu.querySelector('summary').focus(); }
        else { const mobile = this.querySelector('.my-mobile-root[open]'); if (mobile) { mobile.open = false; mobile.querySelector('summary').focus(); } }
      }, options);
      this.addEventListener('focusout', event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) closeMenus(); }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) closeMenus(); }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.my-product-tabs a');
  if (!link) return;
  const panel = document.getElementById(link.hash.slice(1));
  if (panel?.matches('details.my-product-disclosure')) panel.open = true;
});

  } catch(e) { console.error(e); }
})();
})();
